module.exports = require('./lib/fullstore');
